// For more information about this file see https://dove.feathersjs.com/guides/cli/service.shared.html
import type { ClientApplication } from '../../client';
import type { User, UserData, UserPatch, UserQuery, UserService } from './user.class';

export type { User, UserData, UserPatch, UserQuery };

export type UserClientService = Pick<UserService, (typeof userMethods)[number]>;

export const userPath = 'api/user';

export const userMethods: Array<keyof UserService> = [
  'find',
  'get',
  'create',
  'patch',
  'remove',
  'getTopContributors',
];

export const userClient = (client: ClientApplication) => {
  const connection = client.get('connection');

  client.use(userPath, connection.service(userPath), {
    methods: userMethods,
  });
};

// Add this service to the client service type index
declare module '../../client' {
  interface ServiceTypes {
    [userPath]: UserClientService;
  }
}
